import { Link } from 'react-router-dom'
import { Card, EmptyState } from '../components/ui'

export default function NotFound() {
  return (
    <Card>
      <EmptyState title="That page doesn't exist">
        <Link className="btn btn--ghost" to="/" style={{ marginTop: 12 }}>
          Back to home
        </Link>
      </EmptyState>
    </Card>
  )
}
